import { flickityContainNavigation } from 'utils'

$(document).on('watch-section:load', () => {
  flickityContainNavigation('.watch-section .slider')
})
